import { Link } from 'react-router-dom';

export default function SubscriptionSuccess() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800">
      <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="bg-slate-900/85 border border-emerald-500/40 rounded-2xl p-8 shadow-sm text-center">
          <div className="mx-auto h-12 w-12 rounded-full bg-emerald-500/20 flex items-center justify-center mb-4">
            <svg className="h-6 w-6 text-emerald-300" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-slate-100">Subscription active</h1>
          <p className="text-slate-300 mt-2">
            Thanks for subscribing! Your plan is now active and ready to use.
          </p>
          <div className="mt-6 flex justify-center gap-3">
            <Link
              to="/"
              className="px-4 py-2 text-sm font-semibold rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition-colors duration-200"
            >
              Go to Emotion Detector
            </Link>
            <Link
              to="/api-keys"
              className="px-4 py-2 text-sm font-semibold rounded-lg bg-slate-200 text-slate-900 hover:bg-slate-300 transition-colors duration-200"
            >
              Manage API Keys
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
